import Checkbox from './LqVCheckbox'
export default Checkbox.extend({
    name: 'lq-v-switch',
    data () {
        return {
            tagName: 'v-switch'
        }
    }
})